import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import "rc-slider/assets/index.css";
import { setFontWeight } from "../../../../store/actions/image";
import { style } from "../../../../constants/constants";
import Select from "react-select";

// Text attribute options
const SelectOption = ({
  element,
  className,
  attribute,
  placeholder,
  options,
}) => {
  const dispatch = useDispatch();
  const textChanged = useSelector(({ image }) => image.textChanged);
  const canvas = useSelector(({ image }) => image.canvas);

  const onChange = (val) => {
    if (!canvas) {
      return "";
    }
    const item = canvas.getObjects().find((f) => f.id === element.id);
    if (item) {
      dispatch(setFontWeight(element.id, val.value));
    } else {
      return "";
    }
  };
  const getValue = useCallback(() => {
    const item = canvas.getObjects().find((f) => f.id === element.id);
    if (item) {
      const ans = Math.round(item[attribute]);
      if (Number.isNaN(ans)) {
        return "";
      }
      return ans;
    } else {
      return "";
    }
  }, [canvas, element, attribute]);
  return (
    <Select
      styles={style}
      menuPortalTarget={document.body}
      options={options}
      value={{
        label: getValue(),
        value: "",
      }}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};

export default SelectOption;
